module.exports = __webpack_public_path__ + "media/images/Thomas_Jaki-dd19af0165918b2e583f4ae4ad4e41e9.jpg";